export enum AccountType {
  SEPA = 'SEPA',
  INTERNATIONAL = 'INTERNATIONAL'
}
